<template>
  <div>
    <div class="topic">
      <div class="pic"><img src="/static/img/story.jpg" width="100%" alt="Sharkgulf"></div>
      <div class="text">Sharkgulf Technology</div>
      <!-- <div class="tobottom"><img src="/static/img/tobottom.png" width="100%" alt=""></div> -->
    </div>
    <div class="content">
      <div class="c_title">Sharkgulf Technologies Group Limited</div>
      <div class="c_content">Founded in Aug. 2018,<br/>Sharkgulf Technologies Group Limited is an international technology company that creates products and services of smart electric mobility. We have branch establishments worldwide - Hong Kong, Shanghai, Seoul, Budapest, Bangkok, Taipei, etc.<br/><br/><img src="/static/img/gda_red.png" class="fr" alt="">Launched in July, 2019, the Blueshark R1 smart electric scooter<br/>made its debut in Beijing. In October, 2020, the Blueshark R1<br/>proudly won Good Design Award 2020.</div>
      <div class="c_list">We boast the smart electric motorcycle brand – Blueshark.</div>
      <div class="c_list">We’re dedicated to reshaping the industry of electric two-wheel vehicles with automotive technology.</div>
      <div class="c_list">We vision a world where everyone rides a smart electric motorcycle.</div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {

    }
  },
  mounted(){
    let that = this
    window.scrollTo(0,0)
    this.$nextTick(function(){
      window.addEventListener("scroll", that.animateTxt);
    })
  },
  beforeDestroy(){
    window.removeEventListener("scroll", this.animateTxt);
  },
  methods: {
    animateTxt(){
      let top = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
      if(top <= 100){
        this.$emit("hidenav");
      } else {
        this.$emit("shownav");
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/common.less';
.topic{
  position: relative;
  .pic{
    font-size: 0;
  }
  .text{
    position: absolute;
    text-align: center;
    font-size: 45px;
    color: #fff;
    width: 50%;
    height: 100px;
    line-height: 100px;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    font-weight: bold;
  }
  .tobottom{
    position: absolute;
    width: 20px;
    margin: 0 auto;
    left: 0;
    right: 0;
    bottom: 3vw;
  }
}
.content{
  width: 800px;
  margin: 120px auto;
  text-align: left;
  .c_title{
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 3vw;
  }
  .c_content{
    font-size: 18px;
    line-height: 36px;
    color: #666;
    .fr{
      float: right;
      margin-top: 10px;
    }
  }
  .c_list{
    border-top: 1px solid @colorgray;
    padding-top: 40px;
    margin-top: 80px;
    font-size: 22px;
    color: #000;
    line-height: 24px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/en/story.vue